module.exports = __webpack_public_path__ + "static/media/expertise-epic.d42f9a28.jpg";